import * as React from 'react';

import Button from 'components/Button';
import AdminSyncTypeSpreadsheetView from 'admin/rostering/components/AdminSyncTypeSpreadsheetView';
import AdminSyncTypeCleverView from 'admin/rostering/components/AdminSyncTypeCleverView';
import Dialog from 'components/Dialog';
import Container from 'components/Container';
import Heading from 'components/Heading';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
import Row from 'components/Row';
import { SyncType } from 'globalTypes';

type Props = {
  orgName: string;
  selectSyncType: (method: SyncType) => void;
  onClose: () => void;
};

type State = {
  syncType: SyncType;
};

class AdminSyncTypePickerModal extends React.Component<Props, State> {
  state = {
    syncType: SyncType.remindSpreadsheetV2,
  };

  renderHeader() {
    const { orgName } = this.props;
    return (
      <TitleHeader>
        <Text align="right">
          <Button
            color="polar-bear"
            level="secondary"
            size="xsmall"
            onClick={this.handleHideRequest}>
            Close
          </Button>
        </Text>
        <Row size="xxsmall">
          <Text color="thunder" align="left">
            {orgName}
          </Text>
        </Row>
        <Row>
          <Heading levelStyle="1" align="left">
            SIS sync setup
          </Heading>
        </Row>
      </TitleHeader>
    );
  }

  displaySyncType = (syncType: SyncType) => {
    this.setState({ syncType: syncType });
  };

  handleHideRequest = () => {
    this.props.onClose();
  };

  render() {
    const { selectSyncType, onClose } = this.props;
    const body =
      this.state.syncType === SyncType.clever ? (
        <AdminSyncTypeCleverView
          selectSyncType={selectSyncType}
          onClose={onClose}
          displaySyncType={this.displaySyncType}
        />
      ) : (
        <AdminSyncTypeSpreadsheetView
          selectSyncType={selectSyncType}
          onClose={onClose}
          displaySyncType={syncType => this.displaySyncType(syncType)}
          syncType={this.state.syncType}
        />
      );

    return (
      <Dialog box={true} full theme="light">
        <Container className="AdminSyncTypePickerModal" size="large">
          {this.renderHeader()}
          {body}
        </Container>
      </Dialog>
    );
  }
}

export default AdminSyncTypePickerModal;
